import { render, staticRenderFns } from "./requestedHolidays.vue?vue&type=template&id=f34c94f6"
import script from "./requestedHolidays.vue?vue&type=script&lang=js"
export * from "./requestedHolidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports